import TvContentSliderLazyContainer from './TvContentSliderLazyContainer';
export default TvContentSliderLazyContainer;
